import { Injectable } from '@angular/core';
import { ActionButtonVariant } from '../enums/action-button-variant';
import { isNil } from '@web/utils';
import { EntryNotFoundException } from '@web/common';

@Injectable({
  providedIn: 'root',
})
export class ActionButtonVariantCssProviderService {
  /* prettier-ignore */
  private readonly entries = new Map<ActionButtonVariant, string>([
    [ActionButtonVariant.Secondary, 'p-button-secondary'],
    [ActionButtonVariant.SecondaryOutlined, 'p-button-secondary p-button-outlined'],
  ]);

  public getCss(variant: ActionButtonVariant): string {
    const result = this.entries.get(variant);

    if (isNil(result)) {
      const key = ActionButtonVariant[variant];

      throw new EntryNotFoundException(
        `The action button css entry for "${key}" not found.`,
      );
    }

    return result;
  }
}
